import React from 'react';
import {useNavigate} from 'react-router-dom';
import {Link, Typography} from '@mui/material';
import {AlertInfo} from 'presentation/components';
import {AuthorizationsEnum} from 'presentation/constants';
import {translations} from 'presentation/translations-new';
import Icon from 'presentation/icons';
import {AutoSolEnum} from 'main/analytics/gaTagsEnum';

const {learnMore} = translations['pt-br'].commons;
const {exclusiveForProcedures, electives} =
	translations['pt-br'].privateFlow.requestAuthorizations.electiveProceduresNotice;

export function ElectiveProceduresNotice() {
	const navigate = useNavigate();

	return (
		<AlertInfo.Root severity="info" icon={<Icon name="info-outlined" size={20} />}>
			<AlertInfo.Description>
				<Typography variant="body2" color="text.primary" component="span">
					{exclusiveForProcedures}
					<strong> {electives} </strong>&nbsp;
					<Link
						component={'button'}
						onClick={() => {
							navigate(AuthorizationsEnum.INSTRUCTIONS);
						}}
						color="primary.main"
						sx={{cursor: 'pointer', verticalAlign: 'inherit'}}
						data-tag-id={AutoSolEnum.AS_CLICK_SAIBA_MAIS}>
						{learnMore}.
					</Link>
				</Typography>
			</AlertInfo.Description>
		</AlertInfo.Root>
	);
}
